





























































































































import { defineComponent, reactive, toRefs, PropType, computed, watch, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../commons/common"
import AlertArea from "../components/AlertArea.vue";
import DrawArea from "../components/DrawArea.vue";
import { Examinee, ReviewText, ReviewTypeEnum, SheetActivity } from "../modules/teacher/SaitenList"
import VSwatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.css"
import TextDirectionToggle from "../components/TextDirectionToggle.vue";

export interface Data {
  inputScale: number
  selectedPageIdx: number
  headerHeight: number
  footerHeight: number
  selectedReview: any
  copiedReview: any
  errors: string[]
  drawMode: number
  fontSize: number
  lineHeight: number
  keyCode: string
  touchLength: number
  thickness: number
  drawColor: string
  textColor: string
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "draw-area": DrawArea,
    "v-swatches": VSwatches,
    "text-direction-toggle": TextDirectionToggle,
  },
  props: {
    examinee: {
      type: Examinee as PropType<Examinee>,
      required: true
    },
    modalHeight: {
      type: Number as PropType<number>,
      required: true
    },
    imageWidth: {
      type: Number as PropType<number>,
      required: true
    },
    imageHeight: {
      type: Number as PropType<number>,
      required: true
    },
    isReviewOverlay: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false,
    },
  },
  setup (props, context) {

    const DrawModeEnum = Common.DrawModeEnum;

    const state = reactive<Data>({
      inputScale: 50,
      selectedPageIdx: 0,
      headerHeight: 46,
      footerHeight: 35,
      selectedReview: null,
      copiedReview: null,
      errors: [],
      drawMode: Common.DrawModeEnum.None,
      fontSize: 48,
      lineHeight: 0,
      keyCode: null,
      touchLength: 0,
      thickness: 2,
      drawColor: "#FF0000",
      textColor: "#FF0000",
    });

    const imageWrapStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${props.imageWidth * scale.value}px`;
      style["height"] = `${props.imageHeight * scale.value}px`;
      return style;
    });

    const imageAreaHeight = computed((): number => {
      return props.modalHeight - state.headerHeight - state.footerHeight;
    });

    const scale = computed((): number => {
      return Number(state.inputScale / 100);
    });

    const imageAreaMousewheel = (e: WheelEvent) => {
      if(state.keyCode == "Control" || e.ctrlKey){
        e.preventDefault();
        const newScale = state.inputScale - (e.deltaY / 30);
        if(newScale >= 10 && newScale <= 200){
          state.inputScale = newScale;
        }
      }
    }

    const changeExaminee = async (addCount: number) => {
      state.selectedReview = null;
      props.examinee.sheetActivities.forEach(sheetActivity => {
        sheetActivity.reviewTexts.forEach(reviewText => {
          reviewText.is_active = false;
        });
      });
      context.emit("change-review-examinee", props.examinee, addCount);
    }

    const changePage = (idx: number) => {
      state.selectedReview = null;
      props.examinee.sheetActivities.forEach(sheetActivity => {
        sheetActivity.reviewTexts.forEach(reviewText => {
          reviewText.is_active = false;
        });
      });
      state.selectedPageIdx = idx;
    }

    const update = async (isShowConfirm: boolean) => {
      let reviewTexts: ReviewText[] = []
      props.examinee.sheetActivities.forEach(x => {
        reviewTexts = reviewTexts.concat(x.reviewTexts);
      });

      if(isShowConfirm && !window.confirm(`${props.examinee.student_name}さんの講評コメントを更新します。よろしいですか？`)){
        return;
      }

      const param = {
        review_texts: reviewTexts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 && x.height > 0),
        base64_canvases: props.examinee.sheetActivities.map(x => x.base64Canvas),
        sheet_id: props.examinee.sheet_id,
        examinee_id: props.examinee.id,
      }

      context.emit("update-review", param);
    }

    const changeDrawModeFromChild = (drawMode: number) => {
      state.drawMode = drawMode;
      state.selectedReview = null;
    }

    const updateCanvas = (base64Canvas: string, bitCnt: number) => {
      props.examinee.sheetActivities[state.selectedPageIdx].base64Canvas = base64Canvas;
      setIsCanvasDrawed(props.examinee.sheetActivities[state.selectedPageIdx], bitCnt);
    }

    const setIsCanvasDrawed = async (sheetActivity: SheetActivity, bitCnt: number) => {
      sheetActivity.is_canvas_drawed = bitCnt > 1000;
    }

    const loadCanvasStates = (examinee: Examinee) => {
      state.selectedReview = null;
      state.selectedPageIdx = 0;
      for(const sheetActivity of examinee.sheetActivities){
        if(sheetActivity.base64Canvas){
          const canvasImage = new Image();
          canvasImage.src = `data:image/png;base64,${sheetActivity.base64Canvas}`;
          canvasImage.onload = async () => {
            const canvas = document.createElement("canvas") as HTMLCanvasElement;
            canvas.width = props.imageWidth;
            canvas.height = props.imageHeight;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(canvasImage, 0, 0);
            const bitCnt = ctx.getImageData(0, 0, props.imageWidth, props.imageHeight).data.filter(x => x > 0).length;
            setIsCanvasDrawed(sheetActivity, bitCnt);
          };
        }else{
          sheetActivity.is_canvas_drawed = false;
        }
      }
    }

    const addTextStamp = (param: any) => {
      const size = Common.getTextSize({fontSize: state.fontSize, lineHeight: state.lineHeight, direction: context.root.$store.state.textDirection});
      const reviewText = new ReviewText();
      reviewText.sheet_activity_id = props.examinee.sheetActivities[state.selectedPageIdx].id;
      reviewText.idx = props.examinee.sheetActivities[state.selectedPageIdx].idx++;
      reviewText.font_size = state.fontSize;
      reviewText.line_height = 0;
      reviewText.color = state.textColor;
      reviewText.x = param.point.x;
      reviewText.y = param.point.y;
      reviewText.width = size.width;
      reviewText.height = size.height;
      reviewText.direction = context.root.$store.state.textDirection;
      reviewText.base64_text = Common.createBase64Text(reviewText);
      reviewText.review_type = ReviewTypeEnum.Text;
      props.examinee.sheetActivities[state.selectedPageIdx].reviewTexts.push(reviewText);
    }

    const deleteTextStamp = (textStamp: any) => {
      const idx = props.examinee.sheetActivities[state.selectedPageIdx].reviewTexts.indexOf(textStamp);
      props.examinee.sheetActivities[state.selectedPageIdx].reviewTexts.splice(idx, 1);
      if(state.selectedReview == textStamp){
        state.selectedReview = null;
      }
    }

    const deleteImageStamp = (_imageStamp: any) => {
      return;
    }

    const changeSelectedReview = (selectedReview: any) => {
      state.selectedReview = selectedReview;
      if(selectedReview && selectedReview.review_type == ReviewTypeEnum.Text){
        state.textColor = selectedReview.color;
        state.fontSize = selectedReview.font_size;
        state.lineHeight = selectedReview.line_height;
      }
    }

    const keyDown = (e: KeyboardEvent) => {
      if(e.key == "c" && e.ctrlKey && state.selectedReview != null){
        const reviewText = new ReviewText();
        reviewText.text = state.selectedReview.text;
        reviewText.font_size = state.selectedReview.font_size;
        reviewText.line_height = state.selectedReview.line_height;
        reviewText.color = state.selectedReview.color;
        reviewText.x = state.selectedReview.x;
        reviewText.y = state.selectedReview.y;
        reviewText.width = state.selectedReview.width;
        reviewText.height = state.selectedReview.height;
        reviewText.direction = state.selectedReview.direction;
        reviewText.base64_text = state.selectedReview.base64_text;
        reviewText.review_type = ReviewTypeEnum.Text;
        state.copiedReview = reviewText;
      }else if(e.key == "v" && e.ctrlKey && state.copiedReview != null){
        const reviewText = new ReviewText();
        reviewText.sheet_activity_id = props.examinee.sheetActivities[state.selectedPageIdx].id;
        reviewText.idx = props.examinee.sheetActivities[state.selectedPageIdx].idx++;
        reviewText.text = state.copiedReview.text;
        reviewText.font_size = state.copiedReview.font_size;
        reviewText.line_height = state.copiedReview.line_height;
        reviewText.color = state.copiedReview.color;
        reviewText.x = state.copiedReview.x;
        reviewText.y = state.copiedReview.y;
        reviewText.width = state.copiedReview.width;
        reviewText.height = state.copiedReview.height;
        reviewText.direction = state.copiedReview.direction;
        reviewText.base64_text = Common.createBase64Text(reviewText);
        reviewText.review_type = ReviewTypeEnum.Text;
        props.examinee.sheetActivities[state.selectedPageIdx].reviewTexts.push(reviewText);
      }else{
        state.keyCode = e.key;
      }
    }

    const keyUp = (e: KeyboardEvent) => {
      state.keyCode = "";

      if(document.activeElement?.nodeName.toLowerCase() == "textarea"){
        return;
      }

      if(e.key == "Backspace" && state.selectedReview != null){
        const idx = props.examinee.sheetActivities[state.selectedPageIdx].reviewTexts.indexOf(state.selectedReview);
        if(idx >= 0){
          props.examinee.sheetActivities[state.selectedPageIdx].reviewTexts.splice(idx, 1);
        }
        state.selectedReview = null;
      }
    }

    const changeText = () => {
      const size = Common.getTextSize({text: state.selectedReview.text, fontSize: state.selectedReview.font_size, lineHeight: state.selectedReview.line_height, direction: state.selectedReview.direction});

      if(state.selectedReview.direction == Common.DirectionEnum.Vertical){
        const diffW = size.width - state.selectedReview.width;
        state.selectedReview.x -= diffW;
      }

      state.selectedReview.width = size.width;
      state.selectedReview.height = size.height;
      state.selectedReview.base64_text = Common.createBase64Text(state.selectedReview);
    }

    const textFormatChanged = () => {
      if(!state.selectedReview){
        return;
      }

      state.selectedReview.font_size = state.fontSize;
      state.selectedReview.line_height = state.lineHeight;
      state.selectedReview.color = state.textColor;
      const size = Common.getTextSize({text: state.selectedReview.text, fontSize: state.fontSize, lineHeight: state.lineHeight, direction: state.selectedReview.direction});

      if(state.selectedReview.direction == Common.DirectionEnum.Vertical){
        const diffW = size.width - state.selectedReview.width;
        state.selectedReview.x -= diffW;
      }

      state.selectedReview.width = size.width;
      state.selectedReview.height = size.height;
      state.selectedReview.base64_text = Common.createBase64Text(state.selectedReview);
    }

    const changeDrawMode = (drawMode: number) => {
      const current = document.activeElement;
      if(current != null){
        (current as HTMLElement).blur();
      }

      state.selectedReview = null;
      if(state.drawMode == drawMode){
        state.drawMode = DrawModeEnum.None;
      }else{
        state.drawMode = drawMode;
      }
    }

    watch(() => props.examinee, (examinee: Examinee) => {
      if(examinee){
        loadCanvasStates(examinee);
      }
    });

    onMounted(async () => {
      const imageWrap = document.getElementById("image-wrap");
      const imageWrapWidth = imageWrap.clientWidth - 20;
      const imageWrapHeight = imageWrap.clientHeight - 20;
      const perW = imageWrapWidth / props.imageWidth;
      const perH = imageWrapHeight / props.imageHeight;
      state.inputScale = perW > perH ? perH * 100 : perW * 100;
      loadCanvasStates(props.examinee);
      window.addEventListener("keydown", keyDown);
      window.addEventListener("keyup", keyUp);
    });

    onBeforeUnmount(async () => {
      window.removeEventListener("keydown", keyDown);
      window.removeEventListener("keyup", keyUp);
    });

    return {
      ...toRefs(state),
      DrawModeEnum,
      ReviewTypeEnum,
      scale,
      imageAreaHeight,
      imageWrapStyle,
      changeExaminee,
      changePage,
      update,
      imageAreaMousewheel,
      changeDrawModeFromChild,
      updateCanvas,
      addTextStamp,
      deleteTextStamp,
      deleteImageStamp,
      changeSelectedReview,
      changeText,
      textFormatChanged,
      changeDrawMode,
    }
  }
});
